export default {
  elements: {},
  init() {
    this.elements.parent = $("#courtOffences");
    if (this.elements.parent.length > 0) {
      setReferences.apply(this);
      initListners.apply(this);
    }
    this.elements.parent = $("#proBuilder");
    if (this.elements.parent.length > 0) {
      setReferences.apply(this);
      initListners.apply(this);
    }
  },
};
function setReferences() {
  // set elements to select later
  this.elements.searchfield = this.elements.parent.find("#offences-search");
  this.elements.offenceitems = this.elements.parent.find(
    "ul.offences-filter-list > li"
  );
  this.elements.tabs = this.elements.parent.find(".tablink");
  this.elements.tabcontainers = this.elements.parent.find(".city");
}
function initListners() {
  this.elements.searchfield.keyup(() => {
    var searchText = this.elements.searchfield.val();
    this.elements.offenceitems.each((index, item) => {
      var currentLiText = $(item).text(),
        showCurrentLi =
          currentLiText.toLowerCase().indexOf(searchText.toLowerCase()) !== -1;
      $(item).toggle(showCurrentLi);
    });
  });
  this.elements.tabs.click((event) => {
    var $this = $(event.currentTarget),
      tabId = $this.data("tab-id");
    this.elements.tabs.removeClass("active");
    $this.addClass("active");
    this.elements.tabcontainers.hide();
    this.elements.tabcontainers.filter("#" + tabId).show();
  });
}

var selectName = $("#field_30_201 select").attr("name");

// add a hidden element with the same name as the select
var hidden = $('<input type="hidden" name="' + selectName + '">');
hidden.val($("select").val());
hidden.insertAfter($("select"));

//$('#field_30_201 select option').clone().appendTo('#field_30_201 ginput_container_select');

$("#field_30_201 select option")
  .unwrap()
  .each(function () {
    var btn = $('<div class="btn">' + $(this).text() + "</div>");
    //if($(this).is(':checked')) btn.addClass('on');
    $(this).replaceWith(btn);
  });

$(document).on("click", ".btn", function () {
  $(".btn").removeClass("on");
  $(this).addClass("on");
  $('input[name="' + selectName + '"]').val($(this).text());

  var expr = $.trim($(this).text());
  switch (expr) {
    case "Days":
      console.log("Days");
      $("#field_30_203").show();
      $("#field_30_204").hide();
      $("#field_30_205").hide();
      $("#field_30_206").hide();
      break;
    case "Weeks":
      console.log("Weeks");
      $("#field_30_203").hide();
      $("#field_30_204").show();
      $("#field_30_205").hide();
      $("#field_30_206").hide();
      break;
    case "Months":
      console.log("Months");
      $("#field_30_203").hide();
      $("#field_30_204").hide();
      $("#field_30_205").show();
      $("#field_30_206").hide();
      break;
    case "Years":
      console.log("Years");
      $("#field_30_203").hide();
      $("#field_30_204").hide();
      $("#field_30_205").hide();
      $("#field_30_206").show();
      break;
    case "Offences":
      var str = window.location.href;
      if (str.toLowerCase().indexOf("/offences/") == -1) {
        //window.location.href = "/offences/";
      }
      break;
    case "Overarching Guidelines":
      var str = window.location.href;
      if (str.toLowerCase().indexOf("/offences/") == -1) {
       // window.location.href = "/offences/?overarching=true";
      }
      break;
    case "Supplementary Information":
      window.location.href = "/supplementary-information/";
      break;
    default:
      console.log(`Sorry, no options called ${expr}.`);
  }
});



// WEBPACK FOOTER //
// ./scripts/components/offences.js